import { render } from "./BBPsPaymentStatus.vue?vue&type=template&id=4219edda&scoped=true"
import script from "./BBPsPaymentStatus.vue?vue&type=script&lang=js"
export * from "./BBPsPaymentStatus.vue?vue&type=script&lang=js"

import "./BBPsPaymentStatus.vue?vue&type=style&index=0&id=4219edda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4219edda"]])

export default __exports__